import React, { useState } from 'react';
import Select from 'react-select';

const ClassScheduleModal = ({ isOpen, setIsOpen }) => {
    const [openingHours, setOpeningHours] = useState([{ date: '', fromTime: '', toTime: '' }]);
    const [equipments, setequipments] = useState([]);
    const [equipmentsInput, setequipmentsInput] = useState('');

    const handleBlurOrEnter = (setter, inputSetter, value) => {
        const values = value
            .split(",")
            .map((item) => item.trim())
            .filter((item) => item); // Removes empty items
        setter((prev) => [...prev, ...values]); // Append new values to existing ones
        inputSetter(""); // Clear input field
    };

    const removeTag = (setter, indexToRemove) => {
        setter((prev) => prev.filter((_, index) => index !== indexToRemove));
    };

    const handleAddOpeningHour = () => {
        setOpeningHours([...openingHours, { date: '', fromTime: '', toTime: '' }]);
    };

    const handleChangeOpeningHour = (index, field, value) => {
        const newOpeningHours = [...openingHours];
        newOpeningHours[index][field] = value;
        setOpeningHours(newOpeningHours);
    };

    const handleRemoveOpeningHour = (index) => {
        const newOpeningHours = openingHours.filter((_, i) => i !== index);
        setOpeningHours(newOpeningHours);
    };

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
    ];

    const taskLevelOptions = [
        { value: 'beginner', label: 'Beginner' },
        { value: 'intermediate', label: 'Intermediate' },
        { value: 'advanced', label: 'Advanced' },
    ];

    const enrollmentStatusOptions = [
        { value: 'open', label: 'Open' },
        { value: 'closed', label: 'Closed' },
    ];

    const paymentMethodOptions = [
        { value: 'credit_card', label: 'Credit Card' },
        { value: 'cash', label: 'Cash' },
        { value: 'online_transfer', label: 'Online Transfer' },
    ];

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Service/Offering Details</h2>
                <form className="oms-modal-form">
                    <div className="oms-form-group">
                        <label htmlFor="branch-name" className="oms-form-label">
                            Branch Name
                        </label>
                        <input type="text" id="branch-name" placeholder="Enter branch name" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="task-level" className="oms-form-label">
                            Task Level
                        </label>
                        <Select
                            options={taskLevelOptions}
                            placeholder="Select task level"
                            isMulti
                        />
                    </div>

                    {openingHours.map((_, index) => (
                        <div className="oms-form-group" key={index}>
                            <label className="oms-form-label">
                                Frequency {index + 1}
                                {/* Conditionally render the trash icon */}
                                {index !== 0 && (
                                    <button
                                        type="button"
                                        className="trash-button"
                                        onClick={() => handleRemoveOpeningHour(index)}
                                        title="Remove opening hour"
                                    >
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                )}
                            </label>
                            <div className="oms-form-inline">
                                <div className="oms-form-field">
                                    <label htmlFor={`date-${index}`} className="oms-form-label">
                                        Date
                                    </label>
                                    <input
                                        id={`date-${index}`}
                                        type="date"
                                        placeholder="Select date"
                                        value={openingHours[index].date}
                                        onChange={(e) => handleChangeOpeningHour(index, 'date', e.target.value)}
                                    />
                                </div>
                                <div className="oms-form-field">
                                    <label htmlFor={`fromTime-${index}`} className="oms-form-label">
                                        From Time
                                    </label>
                                    <input
                                        id={`fromTime-${index}`}
                                        type="time"
                                        placeholder="From Time"
                                        value={openingHours[index].fromTime}
                                        onChange={(e) => handleChangeOpeningHour(index, 'fromTime', e.target.value)}
                                    />
                                </div>
                                <div className="oms-form-field">
                                    <label htmlFor={`toTime-${index}`} className="oms-form-label">
                                        To Time
                                    </label>
                                    <input
                                        id={`toTime-${index}`}
                                        type="time"
                                        placeholder="To Time"
                                        value={openingHours[index].toTime}
                                        onChange={(e) => handleChangeOpeningHour(index, 'toTime', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                    <button type="button" className="add-opening-button" onClick={handleAddOpeningHour}>
                        Add More Frequency
                    </button>

                    <div className="oms-form-group">
                        <label htmlFor="task-coach" className="oms-form-label">
                            Task Coach
                        </label>
                        <input type="text" id="task-coach" placeholder="Enter task coach" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="task-description" className="oms-form-label">
                            Task Description
                        </label>
                        <textarea id="task-description" placeholder="Enter task description"></textarea>
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="age-group" className="oms-form-label">
                            Age Group
                        </label>
                        <input type="text" id="age-group" placeholder="Enter age group" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="center-address" className="oms-form-label">
                            Center Address
                        </label>
                        <input type="text" id="center-address" placeholder="Enter center address" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="map-link" className="oms-form-label">
                            Map or Direction (Link)
                        </label>
                        <input type="url" id="map-link" placeholder="Enter map or direction link" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="max-participants" className="oms-form-label">
                            Maximum Number of Participants
                        </label>
                        <input type="number" id="max-participants" placeholder="Enter max participants" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="current-participants" className="oms-form-label">
                            Current Number of Enrolled Participants
                        </label>
                        <input type="number" id="current-participants" placeholder="Enter current participants" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="enrollment-status" className="oms-form-label">
                            Enrollment Status
                        </label>
                        <Select options={enrollmentStatusOptions} placeholder="Select enrollment status" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="class-fee" className="oms-form-label">
                            Class Fee
                        </label>
                        <input type="number" id="class-fee" placeholder="Enter class fee" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="payment-method" className="oms-form-label">
                            Payment Method
                        </label>
                        <Select options={paymentMethodOptions} placeholder="Select payment method" />
                    </div>

                    {/* equipments */}
                    <div className="oms-form-group">
                        <label htmlFor="equipments" className="oms-form-label">Equipment required</label>
                        <input
                            type="text"
                            id="equipments"
                            placeholder="Enter equipments separated by commas"
                            value={equipmentsInput}
                            onChange={(e) => setequipmentsInput(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handleBlurOrEnter(setequipments, setequipmentsInput, equipmentsInput);
                                }
                            }}
                            onBlur={() => handleBlurOrEnter(setequipments, setequipmentsInput, equipmentsInput)}
                        />
                        <div>
                            {equipments.map((hobby, index) => (
                                <span key={index} className="tag">{hobby}
                                    <button
                                        type="button"
                                        className="remove-tag-btn"
                                        onClick={() => removeTag(setequipments, index)}
                                    >
                                        ×
                                    </button>
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="dress-code" className="oms-form-label">
                            Dress Code
                        </label>
                        <input type="text" id="dress-code" placeholder="Enter dress code" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="safety-guide" className="oms-form-label">
                            Safety Guide
                        </label>
                        <textarea id="safety-guide" placeholder="Enter safety guide"></textarea>
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="add-notes" className="oms-form-label">
                            Add Notes
                        </label>
                        <textarea id="add-notes" placeholder="Add notes"></textarea>
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="support-contact" className="oms-form-label">
                            Support Contact
                        </label>
                        <input type="text" id="support-contact" placeholder="Enter support contact" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="emergency-contact" className="oms-form-label">
                            Emergency Contact Detail
                        </label>
                        <input type="text" id="emergency-contact" placeholder="Enter emergency contact detail" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions} placeholder="Select status" />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ClassScheduleModal;
